
// src/connects/report-status-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import config from '../config'
import moment from 'moment'
import find from 'lodash/find'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state, ownProps)=> {
  return {
    isFetching: state.activityReport.isFetching,
    isFetchFailed: state.activityReport.isFetchFailed,
    activityReports: state.activityReport.items,
    group: find(state.groups.items, (item)=> item.group_id == ownProps.params.group_id),
    access_token: state.sessions.access_token,
    currentUser: state.user.current,
    isFoldersFetching: state.googleApi.isFoldersFetching,
    isFoldersFetchFailed: state.googleApi.isFoldersFetchFailed,
    folders: state.googleApi.folders,
    isUserInfoFetching: state.googleApi.isUserInfoFetching,
    isUserInfoFetchFailed: state.googleApi.isUserInfoFetchFailed,
    userinfo: state.googleApi.userinfo,
    isUploadFetching: state.googleApi.isUploadFetching,
    isUploadFetchFailed: state.googleApi.isUploadFetchFailed,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> dispatch(actions.fetchActivityReports(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'))),

    fetchActivityReport: (props, direction)=> {
      if (direction == 'prev') {
        const startDate = props.ui.startDate.clone().add(-7, 'days')
        dispatch(actions.fetchActivityReports(props.group.group_id, startDate.format('YYYY-MM-DD')))
        props.updateUI({ startDate })
      }
      else {
        const startDate = props.ui.startDate.clone().add(7, 'days')
        dispatch(actions.fetchActivityReports(props.group.group_id, startDate.format('YYYY-MM-DD')))
        props.updateUI({ startDate })
      }
    },

    exportUrl: (props)=> `${config.baseUrl}v3/export/monthly_summary.xlsx?group_id=${props.group.group_id}&start_date=${moment(props.ui.startDate).startOf('month').format('YYYY-MM-DD')}&access_token=${props.access_token}`,

    openPickupDiaries: (diary_ids)=> dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids }, true)),

    openUserTimeline: (props, user)=> dispatch(actions.openRightSidePage('user_timeline', { group_id: props.group.group_id, user: user, user_id: user.user_id }, true)),

    willUnmount: ()=> {
      dispatch(actions.clearActivityReports()),
      dispatch(actions.clearGoogleDriveFolders())
    },

    fetchUserInfo: ()=> dispatch(actions.fetchGoogleDriveUserInfo()),

    fetchFolders: ()=> {
      dispatch(actions.fetchGoogleDriveFolders())
    },

    cancelGoogleDrive: ()=> {
      dispatch(actions.clearGoogleDriveFolders())
    },

    downloadFile: (props)=> {
      const file_name = 'monthly_summary.xlsx'
      const file_url = config.baseUrl + 'v3/export/monthly_summary.xlsx?group_id=' + props.group.group_id + '&start_date=' + moment(props.ui.startDate).startOf('month').format('YYYY-MM-DD') + '&access_token=' + props.access_token
      dispatch(actions.uploadGoogleDriveFile(props.ui.folder_id, file_name, file_url))
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: { 
    startDate: moment().add(-moment().day(), 'days'),
    index: 0,
    innerWidth: 1000,
    innerHeight: 600,
    active: false,
    user: undefined,
    folder_id: 'undefined',
    gapiReady: false }
  }),
  lifecycle,
  translate(),
  trackPage('report_status'),
)



// WEBPACK FOOTER //
// ./src/connects/report-status-page.js